module.exports = __webpack_public_path__ + "static/media/intro_png.d4140d52.png";